export const UPDATE_BOOKING_SERVICE = 'UPDATE_BOOKING_SERVICE';

/**
 * @return {Object}
 */
export function updateBookingService(bookingService) {
  return {
    type: UPDATE_BOOKING_SERVICE,
    payload: bookingService,
  };
}
